const loadedScripts = new Map();

export const loadExternalScript = (src) => {
  if (!src) {
    return Promise.reject(new Error("Script URL is required"));
  }

  if (loadedScripts.has(src)) {
    return loadedScripts.get(src);
  }

  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) {
    const promise = Promise.resolve();
    loadedScripts.set(src, promise);
    return promise;
  }

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });

  loadedScripts.set(src, promise);
  return promise;
};
